const editorialHero = () => {
    const editorialHeros = document.querySelectorAll('[data-editorial-hero-media] video');
    const handleIntersection = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // Video is in the viewport, play it
                const video = entry.target;
                video.play();
            }
            else {
                // Video is out of the viewport, pause it
                const video = entry.target;
                video.pause();
            }
        });
    };
    const observerOptions = {
        threshold: 0.5, // video pause/play triggered when 50% in viewport
    };
    const observer = new IntersectionObserver(handleIntersection, observerOptions);
    editorialHeros.forEach((intro) => {
        observer.observe(intro);
    });
};
export { editorialHero };
